import { render, staticRenderFns } from "./ResultBlockPrimary.vue?vue&type=template&id=40b7b306&scoped=true&"
import script from "./ResultBlockPrimary.vue?vue&type=script&lang=js&"
export * from "./ResultBlockPrimary.vue?vue&type=script&lang=js&"
import style0 from "./ResultBlockPrimary.vue?vue&type=style&index=0&id=40b7b306&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b7b306",
  null
  
)

export default component.exports